import { Children, isValidElement, useCallback, useEffect } from "react";
import { useConstant } from "../useConstant/index.js";
import { addWorm, removeWorm, setMeta, subscribe, unsubscribe, useSources } from "./store.js";
function useWormholeSources(target) {
  const wormholeId = useConstant(() => window.crypto.randomUUID());
  useEffect(() => {
    subscribe(target, wormholeId);
    return () => {
      unsubscribe(target, wormholeId);
    };
  }, [target, wormholeId]);
  const wormholes = useSources(target);
  const addItem = useCallback(
    (wormholeId2, worm, meta) => {
      const worms = Children.toArray(worm).filter(isValidElement);
      setMeta(target, wormholeId2, meta);
      addWorm(target, wormholeId2, ...worms);
      return () => {
        removeWorm(target, wormholeId2, ...worms);
      };
    },
    [target]
  );
  return [wormholes, addItem];
}
export {
  useWormholeSources
};
//# sourceMappingURL=useWormholeSources.js.map
